// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentStep_root__3XxTB","halfWidth":"PaymentStep_halfWidth__139hL","marginBottom":"PaymentStep_marginBottom__17Mw0","buttons":"PaymentStep_buttons__39YIv"};